/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var h = require("lexical"),
    k = require("@lexical/utils");

function m(a) {
  var b = new URLSearchParams();
  b.append("code", a);

  for (var c = 1; c < arguments.length; c++) {
    b.append("v", arguments[c]);
  }

  throw Error("Minified Lexical error #".concat(a, "; visit https://lexical.dev/docs/error?").concat(b, " for the full message or ") + "use the non-minified dev environment for full errors and additional helpful warnings.");
}

function n(a) {
  var b = 1;

  for (a = a.getParent(); null != a;) {
    if (p(a)) {
      a = a.getParent();

      if (q(a)) {
        b++;
        a = a.getParent();
        continue;
      }

      m(40);
    }

    break;
  }

  return b;
}

function r(a) {
  a = a.getParent();
  q(a) || m(40);
  var b = a;

  for (; null !== b;) {
    b = b.getParent(), q(b) && (a = b);
  }

  return a;
}

function t(a) {
  var b = [];
  a = a.getChildren().filter(p);

  for (var c = 0; c < a.length; c++) {
    var d = a[c],
        e = d.getFirstChild();
    q(e) ? b = b.concat(t(e)) : b.push(d);
  }

  return b;
}

function u(a) {
  return p(a) && q(a.getFirstChild());
}

function v(a) {
  for (; null == a.getNextSibling() && null == a.getPreviousSibling();) {
    var b = a.getParent();
    if (null == b || !p(a) && !q(a)) break;
    a = b;
  }

  a.remove();
}

function w(a) {
  return y().append(a);
}

function z(a, b) {
  return p(a) && (0 === b.length || 1 === b.length && a.is(b[0]) && 0 === a.getChildrenSize());
}

function B(a, b) {
  a.splice(a.getChildrenSize(), 0, b);
}

function C(a, b) {
  if (q(a)) return a;
  var c = a.getPreviousSibling(),
      d = a.getNextSibling(),
      e = y();
  e.setFormat(a.getFormatType());
  e.setIndent(a.getIndent());
  B(e, a.getChildren());
  if (q(c) && b === c.getListType()) return c.append(e), a.remove(), q(d) && b === d.getListType() && (B(c, d.getChildren()), d.remove()), c;
  if (q(d) && b === d.getListType()) return d.getFirstChildOrThrow().insertBefore(e), a.remove(), d;
  b = D(b);
  b.append(e);
  a.replace(b);
  E(b);
  return b;
}

function F(a, b) {
  var c = a.getLastChild();
  var d = b.getFirstChild();
  c && d && u(c) && u(d) && (F(c.getFirstChild(), d.getFirstChild()), d.remove());
  c = b.getChildren();
  0 < c.length && (a.append.apply(a, _toConsumableArray(c)), E(a));
  b.remove();
}

function E(a, b) {
  a = b || a.getChildren();
  if (void 0 !== a) for (b = 0; b < a.length; b++) {
    var f = a[b];

    if (p(f)) {
      var g = f.getValue();
      var c = f,
          d = c.getParent(),
          e = 1;
      null != d && (q(d) ? e = d.getStart() : m(44));
      c = c.getPreviousSiblings();

      for (d = 0; d < c.length; d++) {
        var l = c[d];
        p(l) && !q(l.getFirstChild()) && e++;
      }

      g !== e && f.setValue(e);
    }
  }
}

function G(a) {
  if (!u(a)) {
    var b = a.getParent(),
        c = b ? b.getParent() : void 0,
        d = c ? c.getParent() : void 0;

    if (q(d) && p(c) && q(b)) {
      var e = b ? b.getFirstChild() : void 0,
          f = b ? b.getLastChild() : void 0;
      if (a.is(e)) c.insertBefore(a), b.isEmpty() && c.remove();else if (a.is(f)) c.insertAfter(a), b.isEmpty() && c.remove();else {
        var g = b.getListType();
        e = y();
        var l = D(g);
        e.append(l);
        a.getPreviousSiblings().forEach(function (x) {
          return l.append(x);
        });
        f = y();
        g = D(g);
        f.append(g);
        B(g, a.getNextSiblings());
        c.insertBefore(e);
        c.insertAfter(f);
        c.replace(a);
      }
      E(b);
      E(d);
    }
  }
}

var H = /*#__PURE__*/function (_h$ElementNode) {
  _inherits(H, _h$ElementNode);

  var _super = _createSuper(H);

  function H(a, b, c) {
    var _this;

    _classCallCheck(this, H);

    _this = _super.call(this, c);
    _this.__value = void 0 === a ? 1 : a;
    _this.__checked = b;
    return _this;
  }

  _createClass(H, [{
    key: "createDOM",
    value: function createDOM(a) {
      var b = document.createElement("li"),
          c = this.getParent();
      q(c) && "check" === c.getListType() && I(b, this, null);
      b.value = this.__value;
      J(b, a.theme, this);
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b, c) {
      var d = this.getParent();
      q(d) && "check" === d.getListType() && I(b, this, a);
      b.value = this.__value;
      J(b, c.theme, this);
      return !1;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(H.prototype), "exportJSON", this).call(this)), {}, {
        checked: this.getChecked(),
        type: "listitem",
        value: this.getValue(),
        version: 1
      });
    }
  }, {
    key: "append",
    value: function append() {
      for (var b = 0; b < arguments.length; b++) {
        var c = b < 0 || arguments.length <= b ? undefined : arguments[b];

        if (h.$isElementNode(c) && this.canMergeWith(c)) {
          var d = c.getChildren();
          this.append.apply(this, _toConsumableArray(d));
          c.remove();
        } else _get(_getPrototypeOf(H.prototype), "append", this).call(this, c);
      }

      return this;
    }
  }, {
    key: "replace",
    value: function replace(a, b) {
      if (p(a)) return _get(_getPrototypeOf(H.prototype), "replace", this).call(this, a);
      this.setIndent(0);
      var c = this.getParentOrThrow();
      if (!q(c)) return a;
      if (c.__first === this.getKey()) c.insertBefore(a);else if (c.__last === this.getKey()) c.insertAfter(a);else {
        var d = D(c.getListType()),
            e = this.getNextSibling();

        for (; e;) {
          var f = e;
          e = e.getNextSibling();
          d.append(f);
        }

        c.insertAfter(a);
        a.insertAfter(d);
      }
      b && this.getChildren().forEach(function (d) {
        a.append(d);
      });
      this.remove();
      0 === c.getChildrenSize() && c.remove();
      return a;
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var c = this.getParentOrThrow();
      q(c) || m(39);
      var d = this.getNextSiblings();
      if (p(a)) return b = _get(_getPrototypeOf(H.prototype), "insertAfter", this).call(this, a, b), a = a.getParentOrThrow(), q(a) && E(a), b;

      if (q(a)) {
        c = a;
        a = a.getChildren();

        for (d = a.length - 1; 0 <= d; d--) {
          c = a[d], this.insertAfter(c, b);
        }

        return c;
      }

      c.insertAfter(a, b);

      if (0 !== d.length) {
        var e = D(c.getListType());
        d.forEach(function (f) {
          return e.append(f);
        });
        a.insertAfter(e, b);
      }

      return a;
    }
  }, {
    key: "remove",
    value: function remove(a) {
      var b = this.getPreviousSibling(),
          c = this.getNextSibling();

      _get(_getPrototypeOf(H.prototype), "remove", this).call(this, a);

      b && c && u(b) && u(c) ? (F(b.getFirstChild(), c.getFirstChild()), c.remove()) : c && (a = c.getParent(), q(a) && E(a));
    }
  }, {
    key: "insertNewAfter",
    value: function insertNewAfter(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      a = y(null == this.__checked ? void 0 : !1);
      this.insertAfter(a, b);
      return a;
    }
  }, {
    key: "collapseAtStart",
    value: function collapseAtStart(a) {
      var b = h.$createParagraphNode();
      this.getChildren().forEach(function (f) {
        return b.append(f);
      });
      var c = this.getParentOrThrow(),
          d = c.getParentOrThrow();
      var e = p(d);
      1 === c.getChildrenSize() ? e ? (c.remove(), d.select()) : (c.insertBefore(b), c.remove(), c = a.anchor, a = a.focus, d = b.getKey(), "element" === c.type && c.getNode().is(this) && c.set(d, c.offset, "element"), "element" === a.type && a.getNode().is(this) && a.set(d, a.offset, "element")) : (c.insertBefore(b), this.remove());
      return !0;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.getLatest().__value;
    }
  }, {
    key: "setValue",
    value: function setValue(a) {
      this.getWritable().__value = a;
    }
  }, {
    key: "getChecked",
    value: function getChecked() {
      return this.getLatest().__checked;
    }
  }, {
    key: "setChecked",
    value: function setChecked(a) {
      this.getWritable().__checked = a;
    }
  }, {
    key: "toggleChecked",
    value: function toggleChecked() {
      this.setChecked(!this.__checked);
    }
  }, {
    key: "getIndent",
    value: function getIndent() {
      var a = this.getParent();
      if (null === a) return this.getLatest().__indent;
      a = a.getParentOrThrow();
      var b = 0;

      for (; p(a);) {
        a = a.getParentOrThrow().getParentOrThrow(), b++;
      }

      return b;
    }
  }, {
    key: "setIndent",
    value: function setIndent(a) {
      "number" === typeof a && -1 < a || m(117);
      var b = this.getIndent();

      for (; b !== a;) {
        if (b < a) {
          a: {
            var c = new Set();
            if (u(this) || c.has(this.getKey())) break a;
            var g = this.getParent();
            var d = this.getNextSibling(),
                e = this.getPreviousSibling();

            if (u(d) && u(e)) {
              if (e = e.getFirstChild(), q(e)) {
                e.append(this);
                var f = d.getFirstChild();
                q(f) && (f = f.getChildren(), B(e, f), d.remove(), c.add(d.getKey()));
                E(e);
              }
            } else u(d) ? (d = d.getFirstChild(), q(d) && (c = d.getFirstChild(), null !== c && c.insertBefore(this), E(d))) : u(e) ? (d = e.getFirstChild(), q(d) && (d.append(this), E(d))) : q(g) && (c = y(), f = D(g.getListType()), c.append(f), f.append(this), e ? e.insertAfter(c) : d ? d.insertBefore(c) : g.append(c), E(f));

            q(g) && E(g);
          }

          b++;
        } else G(this), b--;
      }

      return this;
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(a) {
      if (p(a)) {
        var b = this.getParentOrThrow();

        if (q(b)) {
          var c = this.getNextSiblings();
          E(b, c);
        }
      }

      return _get(_getPrototypeOf(H.prototype), "insertBefore", this).call(this, a);
    }
  }, {
    key: "canInsertAfter",
    value: function canInsertAfter(a) {
      return p(a);
    }
  }, {
    key: "canReplaceWith",
    value: function canReplaceWith(a) {
      return p(a);
    }
  }, {
    key: "canMergeWith",
    value: function canMergeWith(a) {
      return h.$isParagraphNode(a) || p(a);
    }
  }, {
    key: "extractWithChild",
    value: function extractWithChild(a, b) {
      if (!h.$isRangeSelection(b)) return !1;
      a = b.anchor.getNode();
      var c = b.focus.getNode();
      return this.isParentOf(a) && this.isParentOf(c) && this.getTextContent().length === b.getTextContent().length;
    }
  }, {
    key: "isParentRequired",
    value: function isParentRequired() {
      return !0;
    }
  }, {
    key: "createParentElementNode",
    value: function createParentElementNode() {
      return D("bullet");
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "listitem";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new H(a.__value, a.__checked, a.__key);
    }
  }, {
    key: "transform",
    value: function transform() {
      return function (a) {
        var b = a.getParent();
        q(b) && (E(b), "check" !== b.getListType() && null != a.getChecked() && a.setChecked(void 0));
      };
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        li: function li() {
          return {
            conversion: K,
            priority: 0
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = y();
      b.setChecked(a.checked);
      b.setValue(a.value);
      b.setFormat(a.format);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return H;
}(h.ElementNode);

function J(a, b, c) {
  var d = [],
      e = [];
  var f = (b = b.list) ? b.listitem : void 0;
  if (b && b.nested) var g = b.nested.listitem;
  void 0 !== f && (f = f.split(" "), d.push.apply(d, _toConsumableArray(f)));

  if (b) {
    f = c.getParent();
    f = q(f) && "check" === f.getListType();
    var l = c.getChecked();
    f && !l || e.push(b.listitemUnchecked);
    f && l || e.push(b.listitemChecked);
    f && d.push(l ? b.listitemChecked : b.listitemUnchecked);
  }

  void 0 !== g && (g = g.split(" "), c.getChildren().some(function (l) {
    return q(l);
  }) ? d.push.apply(d, _toConsumableArray(g)) : e.push.apply(e, _toConsumableArray(g)));
  0 < e.length && k.removeClassNamesFromElement.apply(k, [a].concat(e));
  0 < d.length && k.addClassNamesToElement.apply(k, [a].concat(d));
}

function I(a, b, c) {
  q(b.getFirstChild()) ? (a.removeAttribute("role"), a.removeAttribute("tabIndex"), a.removeAttribute("aria-checked")) : (a.setAttribute("role", "checkbox"), a.setAttribute("tabIndex", "-1"), c && b.__checked === c.__checked || a.setAttribute("aria-checked", b.getChecked() ? "true" : "false"));
}

function K(a) {
  a = k.isHTMLElement(a) && "true" === a.getAttribute("aria-checked");
  return {
    node: y(a)
  };
}

function y(a) {
  return h.$applyNodeReplacement(new H(void 0, a));
}

function p(a) {
  return a instanceof H;
}

var L = /*#__PURE__*/function (_h$ElementNode2) {
  _inherits(L, _h$ElementNode2);

  var _super2 = _createSuper(L);

  function L(a, b, c) {
    var _this2;

    _classCallCheck(this, L);

    _this2 = _super2.call(this, c);
    _this2.__listType = a = N[a] || a;
    _this2.__tag = "number" === a ? "ol" : "ul";
    _this2.__start = b;
    return _this2;
  }

  _createClass(L, [{
    key: "getTag",
    value: function getTag() {
      return this.__tag;
    }
  }, {
    key: "setListType",
    value: function setListType(a) {
      var b = this.getWritable();
      b.__listType = a;
      b.__tag = "number" === a ? "ol" : "ul";
    }
  }, {
    key: "getListType",
    value: function getListType() {
      return this.__listType;
    }
  }, {
    key: "getStart",
    value: function getStart() {
      return this.__start;
    }
  }, {
    key: "createDOM",
    value: function createDOM(a) {
      var b = document.createElement(this.__tag);
      1 !== this.__start && b.setAttribute("start", String(this.__start));
      b.__lexicalListType = this.__listType;
      O(b, a.theme, this);
      return b;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM(a, b, c) {
      if (a.__tag !== this.__tag) return !0;
      O(b, c.theme, this);
      return !1;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM(a) {
      var _get$call = _get(_getPrototypeOf(L.prototype), "exportDOM", this).call(this, a);

      a = _get$call.element;
      a && k.isHTMLElement(a) && (1 !== this.__start && a.setAttribute("start", String(this.__start)), "check" === this.__listType && a.setAttribute("__lexicalListType", "check"));
      return {
        element: a
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(L.prototype), "exportJSON", this).call(this)), {}, {
        listType: this.getListType(),
        start: this.getStart(),
        tag: this.getTag(),
        type: "list",
        version: 1
      });
    }
  }, {
    key: "canBeEmpty",
    value: function canBeEmpty() {
      return !1;
    }
  }, {
    key: "canIndent",
    value: function canIndent() {
      return !1;
    }
  }, {
    key: "append",
    value: function append() {
      for (var c = 0; c < arguments.length; c++) {
        var b = c < 0 || arguments.length <= c ? undefined : arguments[c];
        if (p(b)) _get(_getPrototypeOf(L.prototype), "append", this).call(this, b);else {
          var d = y();
          q(b) ? d.append(b) : h.$isElementNode(b) ? (b = h.$createTextNode(b.getTextContent()), d.append(b)) : d.append(b);

          _get(_getPrototypeOf(L.prototype), "append", this).call(this, d);
        }
      }

      E(this);
      return this;
    }
  }, {
    key: "extractWithChild",
    value: function extractWithChild(a) {
      return p(a);
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "list";
    }
  }, {
    key: "clone",
    value: function clone(a) {
      return new L(a.__listType || N[a.__tag], a.__start, a.__key);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        ol: function ol() {
          return {
            conversion: P,
            priority: 0
          };
        },
        ul: function ul() {
          return {
            conversion: P,
            priority: 0
          };
        }
      };
    }
  }, {
    key: "importJSON",
    value: function importJSON(a) {
      var b = D(a.listType, a.start);
      b.setFormat(a.format);
      b.setIndent(a.indent);
      b.setDirection(a.direction);
      return b;
    }
  }]);

  return L;
}(h.ElementNode);

function O(a, b, c) {
  var d = [],
      e = [];
  var f = b.list;

  if (void 0 !== f) {
    var l = f["".concat(c.__tag, "Depth")] || [];
    b = n(c) - 1;
    var x = b % l.length;
    var g = l[x];
    var M = f[c.__tag],
        A;
    f = f.nested;
    void 0 !== f && f.list && (A = f.list);
    void 0 !== M && d.push(M);
    if (void 0 !== g) for (g = g.split(" "), d.push.apply(d, _toConsumableArray(g)), g = 0; g < l.length; g++) {
      g !== x && e.push(c.__tag + g);
    }
    void 0 !== A && (c = A.split(" "), 1 < b ? d.push.apply(d, _toConsumableArray(c)) : e.push.apply(e, _toConsumableArray(c)));
  }

  0 < e.length && k.removeClassNamesFromElement.apply(k, [a].concat(e));
  0 < d.length && k.addClassNamesToElement.apply(k, [a].concat(d));
}

function Q(a) {
  var b = [];

  for (var d = 0; d < a.length; d++) {
    var c = a[d];
    p(c) ? (b.push(c), c = c.getChildren(), 1 < c.length && c.forEach(function (e) {
      q(e) && b.push(w(e));
    })) : b.push(w(c));
  }

  return b;
}

function P(a) {
  var b = a.nodeName.toLowerCase(),
      c = null;
  "ol" === b ? c = D("number", a.start) : "ul" === b && (c = k.isHTMLElement(a) && "check" === a.getAttribute("__lexicallisttype") ? D("check") : D("bullet"));
  return {
    after: Q,
    node: c
  };
}

var N = {
  ol: "number",
  ul: "bullet"
};

function D(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return h.$applyNodeReplacement(new L(a, b));
}

function q(a) {
  return a instanceof L;
}

var R = h.createCommand("INSERT_UNORDERED_LIST_COMMAND"),
    S = h.createCommand("INSERT_ORDERED_LIST_COMMAND"),
    T = h.createCommand("INSERT_CHECK_LIST_COMMAND"),
    U = h.createCommand("REMOVE_LIST_COMMAND");
exports.$createListItemNode = y;
exports.$createListNode = D;
exports.$getListDepth = n;

exports.$handleListInsertParagraph = function () {
  var a = h.$getSelection();
  if (!h.$isRangeSelection(a) || !a.isCollapsed()) return !1;
  a = a.anchor.getNode();
  if (!p(a) || 0 !== a.getChildrenSize()) return !1;
  var b = r(a),
      c = a.getParent();
  q(c) || m(40);
  var d = c.getParent(),
      e;
  if (h.$isRootOrShadowRoot(d)) e = h.$createParagraphNode(), b.insertAfter(e);else if (p(d)) e = y(), d.insertAfter(e);else return !1;
  e.select();
  b = a.getNextSiblings();

  if (0 < b.length) {
    var f = D(c.getListType());
    h.$isParagraphNode(e) ? e.insertAfter(f) : (c = y(), c.append(f), e.insertAfter(c));
    b.forEach(function (g) {
      g.remove();
      f.append(g);
    });
  }

  v(a);
  return !0;
};

exports.$isListItemNode = p;
exports.$isListNode = q;
exports.INSERT_CHECK_LIST_COMMAND = T;
exports.INSERT_ORDERED_LIST_COMMAND = S;
exports.INSERT_UNORDERED_LIST_COMMAND = R;
exports.ListItemNode = H;
exports.ListNode = L;
exports.REMOVE_LIST_COMMAND = U;

exports.insertList = function (a, b) {
  a.update(function () {
    var c = h.$getSelection();

    if (h.$isRangeSelection(c) || h.DEPRECATED_$isGridSelection(c)) {
      var d = c.getNodes();
      c = c.anchor.getNode();
      var e = c.getParent();
      if (z(c, d)) d = D(b), h.$isRootOrShadowRoot(e) ? (c.replace(d), e = y(), h.$isElementNode(c) && (e.setFormat(c.getFormatType()), e.setIndent(c.getIndent())), d.append(e)) : p(c) && (c = c.getParentOrThrow(), B(d, c.getChildren()), c.replace(d));else for (c = new Set(), e = 0; e < d.length; e++) {
        var f = d[e];
        if (h.$isElementNode(f) && f.isEmpty() && !c.has(f.getKey())) C(f, b);else if (h.$isLeafNode(f)) for (f = f.getParent(); null != f;) {
          var l = f.getKey();

          if (q(f)) {
            if (!c.has(l)) {
              var g = D(b);
              B(g, f.getChildren());
              f.replace(g);
              E(g);
              c.add(l);
            }

            break;
          } else {
            g = f.getParent();

            if (h.$isRootOrShadowRoot(g) && !c.has(l)) {
              c.add(l);
              C(f, b);
              break;
            }

            f = g;
          }
        }
      }
    }
  });
};

exports.removeList = function (a) {
  a.update(function () {
    var b = h.$getSelection();

    if (h.$isRangeSelection(b)) {
      var c = new Set(),
          d = b.getNodes(),
          e = b.anchor.getNode();
      if (z(e, d)) c.add(r(e));else for (e = 0; e < d.length; e++) {
        var f = d[e];
        h.$isLeafNode(f) && (f = k.$getNearestNodeOfType(f, H), null != f && c.add(r(f)));
      }

      var _iterator = _createForOfIteratorHelper(c),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var g = _step.value;
          c = g;
          d = t(g);

          var _iterator2 = _createForOfIteratorHelper(d),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var l = _step2.value;
              d = h.$createParagraphNode(), B(d, l.getChildren()), c.insertAfter(d), c = d, l.__key === b.anchor.key && b.anchor.set(d.getKey(), 0, "element"), l.__key === b.focus.key && b.focus.set(d.getKey(), 0, "element"), l.remove();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          g.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  });
};